import React, { Component, Fragment } from 'react';
import { Card, Col, Row, Tag, Divider, Button, Input } from 'antd';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import moment from 'moment-timezone';

@inject('store')
@observer
export class LandingView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            recent: [],
            popular: [],
            q: '',
            base: [],
            tags: [],
            bot_types: ['Apex'],
            results: null
        };
    }

    async componentDidMount() {
        try {
            const { data } = await this.props.store.stratCenter.recent();
            const { data: popular } = await this.props.store.stratCenter.popular();
            this.setState({ recent: data.listings, popular: popular.listings });
        } catch (e) {}
    }

    async handleSearch() {
        const { data } = await this.props.store.stratCenter.search({
            q: this.state.q,
            base: this.state.base,
            tags: this.state.tags,
            bot_type: this.state.bot_types
        });

        this.setState({ results: data.listings });
    }

    renderSearchResults() {
        const { results } = this.state;
        const timezone = this.props.store.userStore.currentUser.timezone;

        if (results) {
            if (!results.length) {
                return (
                    <Fragment>
                        <h1>Search Results</h1>
                        <p>No results were found for your search</p>
                        <Divider></Divider>
                    </Fragment>
                );
            }

            return (
                <Fragment>
                    <h1>Search Results ({this.state.results.length})</h1>
                    {this.state.results.map((listing, i) => {
                        return (
                            <div key={i} style={{ marginBottom: 10 }}>
                                <Link to={`/a/strat-center/listing/${listing._id}`}>
                                    <Card
                                        title={`${listing.name} by ${listing.author}`}
                                        bordered={false}
                                        hoverable
                                        extra={
                                            <Tag color={'#a187ff'}>
                                                {this.caps(listing.listing_type)}
                                            </Tag>
                                        }
                                    >
                                        <p>{listing.description}</p>

                                        <b>Bot Type: </b>
                                        <Tag color={'#a187ff'}>
                                            {this.caps(listing.bot_type || 'Apex')}
                                        </Tag>

                                        <b>Supported Base: </b>
                                        {listing.supported_base.map((base, i) => (
                                            <Tag key={i}>{base}</Tag>
                                        ))}
                                        {listing.tags.length ? (
                                            <Fragment>
                                                <b>Tags:</b>{' '}
                                                {listing.tags.map((base, i) => (
                                                    <Tag key={i}>{base}</Tag>
                                                ))}
                                            </Fragment>
                                        ) : null}

                                        <div style={{ textAlign: 'right', fontSize: 11 }}>
                                            Last updated:{' '}
                                            {moment(listing.updated_at)
                                                .tz(timezone)
                                                .format('DD/MM/YYYY hh:mm:ss a')}
                                        </div>
                                    </Card>
                                </Link>
                            </div>
                        );
                    })}
                    <Divider></Divider>
                </Fragment>
            );
        }

        return null;
    }

    render() {
        const timezone = this.props.store.userStore.currentUser.timezone;

        return (
            <Fragment>
                <div
                    style={{
                        background: 'url(/background1.jpg)',
                        height: 250,
                        backgroundPosition: '92% 53%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <h1
                        style={{
                            textAlign: 'center',
                            fontSize: '4em',
                            color: '#2f2552',
                            fontFamily: 'exo',
                            fontWeight: 'bold'
                        }}
                    >
                        Strategy Center
                    </h1>
                </div>
                <div style={{ marginTop: 15, textAlign: 'right' }}>
                    <Button
                        type={'primary'}
                        onClick={() => this.props.history.push('/a/strat-center/my-listings')}
                    >
                        My Listings
                    </Button>
                </div>
                <Row gutter={24} style={{ marginTop: 15 }}>
                    <Col md={6}>
                        <Card bordered={false}>
                            <div style={{ marginBottom: 10 }}>
                                <Input
                                    value={this.state.q}
                                    onChange={e => this.setState({ q: e.target.value })}
                                />
                            </div>

                            <div style={{ marginBottom: 10 }}>
                                <b>Base:</b>{' '}
                                {[
                                    'BTC',
                                    'ETH',
                                    'XRP',
                                    'BNB',
                                    'USDT',
                                    'TUSD',
                                    'PAX',
                                    'USDC',
                                    'USD'
                                ].map((tag, i) => (
                                    <Tag
                                        color={this.state.base.indexOf(tag) >= 0 ? '#a187ff' : null}
                                        key={i}
                                        onClick={() => {
                                            let next = [...this.state.base];
                                            if (next.indexOf(tag) >= 0) {
                                                next.splice(next.indexOf(tag), 1);
                                            } else {
                                                next.push(tag);
                                            }
                                            this.setState({ base: next });
                                        }}
                                    >
                                        {tag}
                                    </Tag>
                                ))}
                            </div>

                            <div style={{ marginBottom: 10 }}>
                                <b>Tags:</b>{' '}
                                {[
                                    'Scalper',
                                    'Market Maker',
                                    'Swing Trader',
                                    'Automation',
                                    'ART',
                                    'ADCA',
                                    'SOTA',
                                    'TSL',
                                    'PP',
                                    'DPP'
                                ].map((tag, i) => (
                                    <Tag
                                        key={i}
                                        color={this.state.tags.indexOf(tag) >= 0 ? '#a187ff' : null}
                                        onClick={() => {
                                            let next = [...this.state.tags];
                                            if (next.indexOf(tag) >= 0) {
                                                next.splice(next.indexOf(tag), 1);
                                            } else {
                                                next.push(tag);
                                            }
                                            this.setState({ tags: next });
                                        }}
                                    >
                                        {tag}
                                    </Tag>
                                ))}
                            </div>

                            <div style={{ marginBottom: 10 }}>
                                <b>Bot:</b>{' '}
                                {['Apex', 'Odyssey'].map((tag, i) => (
                                    <Tag
                                        key={i}
                                        color={
                                            this.state.bot_types.indexOf(tag) >= 0
                                                ? '#a187ff'
                                                : null
                                        }
                                        onClick={() => {
                                            let next = [...this.state.bot_types];
                                            if (next.indexOf(tag) >= 0) {
                                                next.splice(next.indexOf(tag), 1);
                                            } else {
                                                next.push(tag);
                                            }
                                            this.setState({ bot_types: next });
                                        }}
                                    >
                                        {tag}
                                    </Tag>
                                ))}
                            </div>

                            <div style={{ textAlign: 'right' }}>
                                <Button
                                    onClick={() =>
                                        this.setState({ results: null, q: '', base: [], tags: [] })
                                    }
                                >
                                    Clear
                                </Button>
                                &nbsp;&nbsp;&nbsp;
                                <Button
                                    type={'primary'}
                                    icon={'search'}
                                    onClick={this.handleSearch.bind(this)}
                                >
                                    Search
                                </Button>
                            </div>
                        </Card>
                    </Col>
                    <Col md={18}>
                        {this.renderSearchResults()}

                        <h1>Most Popular</h1>
                        <p>Popular strategies voted for by the community</p>

                        {this.state.popular.map((listing, i) => {
                            return (
                                <div key={i} style={{ marginBottom: 10 }}>
                                    <Link to={`/a/strat-center/listing/${listing._id}`}>
                                        <Card
                                            title={`${listing.name} by ${listing.author}`}
                                            bordered={false}
                                            hoverable
                                            extra={
                                                <Tag color={'#a187ff'}>
                                                    {this.caps(listing.listing_type)}
                                                </Tag>
                                            }
                                        >
                                            <p>{listing.description}</p>

                                            <b>Bot Type: </b>
                                            <Tag color={'#a187ff'}>
                                                {this.caps(listing.bot_type || 'Apex')}
                                            </Tag>

                                            <b>Supported Base: </b>
                                            {listing.supported_base.map((base, i) => (
                                                <Tag key={i}>{base}</Tag>
                                            ))}
                                            {listing.tags.length ? (
                                                <Fragment>
                                                    <b>Tags:</b>{' '}
                                                    {listing.tags.map((base, i) => (
                                                        <Tag key={i}>{base}</Tag>
                                                    ))}
                                                </Fragment>
                                            ) : null}

                                            <div style={{ textAlign: 'right', fontSize: 11 }}>
                                                Last updated:{' '}
                                                {moment(listing.updated_at)
                                                    .tz(timezone)
                                                    .format('DD/MM/YYYY hh:mm:ss a')}
                                            </div>
                                        </Card>
                                    </Link>
                                </div>
                            );
                        })}

                        <Divider></Divider>

                        <h1>Recently Shared</h1>
                        <p>Strategies recently shared by community members</p>

                        {this.state.recent.map((listing, i) => {
                            return (
                                <div key={i} style={{ marginBottom: 10 }}>
                                    <Link to={`/a/strat-center/listing/${listing._id}`}>
                                        <Card
                                            title={`${listing.name} - ${listing.author}`}
                                            bordered={false}
                                            hoverable
                                            extra={
                                                <Tag color={'#a187ff'}>
                                                    {this.caps(listing.listing_type)}
                                                </Tag>
                                            }
                                        >
                                            <p>{listing.description}</p>

                                            <b>Bot Type: </b>
                                            <Tag color={'#a187ff'}>
                                                {this.caps(listing.bot_type || 'Apex')}
                                            </Tag>

                                            <b>Supported Base: </b>
                                            {listing.supported_base.map((base, i) => (
                                                <Tag key={i}>{base}</Tag>
                                            ))}
                                            {listing.tags.length ? (
                                                <Fragment>
                                                    <b>Tags:</b>{' '}
                                                    {listing.tags.map((base, i) => (
                                                        <Tag key={i}>{base}</Tag>
                                                    ))}
                                                </Fragment>
                                            ) : null}

                                            <div style={{ textAlign: 'right', fontSize: 11 }}>
                                                Last updated:{' '}
                                                {moment(listing.updated_at)
                                                    .tz(timezone)
                                                    .format('DD/MM/YYYY hh:mm:ss a')}
                                            </div>
                                        </Card>
                                    </Link>
                                </div>
                            );
                        })}
                    </Col>
                </Row>
            </Fragment>
        );
    }

    caps(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
}



// WEBPACK FOOTER //
// ./src/Account/StratCenter/Landing.js